import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { ThemeService } from 'app/shared/services/theme.service';
@Component({
  selector: 'app-campaign-card-overlay',
  templateUrl: './campaign-card-overlay.component.html',
  styleUrl: './campaign-card-overlay.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignCardOverlayComponent {
  private readonly themeService = inject(ThemeService);
  @Input() imageUrl: string;
  @Input() name = '';

  public readonly fallbackImage = this.themeService.isDarkThemeBS.value
    ? 'assets/img/campaign/thumbnail-darkmode.png'
    : 'assets/img/campaign/preview_no_image.png';

  public onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = this.fallbackImage;
  }
}
